import { createAsyncThunk } from '@reduxjs/toolkit';
import { auth } from '../../utils/firebase';

export const signIn = createAsyncThunk(
  'auth/signin',
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const result = await auth.signInWithEmailAndPassword(email, password);
      return result;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const signOut = createAsyncThunk(
  'auth/signout',
  async (_, { rejectWithValue }) => {
    try {
      return auth.signOut();
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
